'use strict';

import React from 'react';
import { createHomepageStore } from '../../redux/store';
import { renderComponent } from '@src/utils/renderer/client-renderer';
import Homepage from '@src/views/home/index';

if (window.APP === 'homepage') {
    const store = createHomepageStore(window.REDUX_DATA);

    renderComponent(<Homepage />, {
        store,
        enableQueryClient: true,
        useHydrateRoot: true
    });
}
